import type { VariantProps } from 'class-variance-authority';
import { cva } from 'class-variance-authority';
import * as React from 'react';
import { CaptionAccentTypography, Conflict } from 'ui';
import { cn } from '@utils';

const CONFLICT_ICON_SIZE = 20;

type Props = VariantProps<typeof BannerVariants> & {
	title?: string;
};

export const BannerVariants = cva('flex items-center justify-center gap-[0.3rem] rounded-lg p-[0.25rem]', {
	variants: {
		variant: {
			default: '',
			error: 'bg-[#FBE4E4] text-error',
		},
	},
	defaultVariants: {
		variant: 'default',
	},
});

export const Banner: React.FC<Props> = ({ title, variant }) => {
	return (
		<div className={cn(BannerVariants({ variant }), !title ? 'opacity-0' : 'opacity-100')} data-testid="auth-error-banner">
			<Conflict height={CONFLICT_ICON_SIZE} width={CONFLICT_ICON_SIZE} />
			<CaptionAccentTypography className="text-current">{title}</CaptionAccentTypography>
		</div>
	);
};
